import { render, staticRenderFns } from "./Editor.vue?vue&type=template&id=5bb11793&scoped=true&"
import script from "./Editor.vue?vue&type=script&lang=ts&"
export * from "./Editor.vue?vue&type=script&lang=ts&"
import style0 from "./Editor.vue?vue&type=style&index=0&id=5bb11793&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb11793",
  null
  
)

export default component.exports